module.exports = __webpack_public_path__ + "media/images/flags/1x1/mkd-a74709b6f3bbc3b6a825d94272dd21b3.svg";